import LocalCart from '@/class/LocalCart';
import HtmlBuilder from '@/class/HtmlBuilder';
import SelectField from '@/fields/SelectField';
import ElementField from '@/fields/ElementField';
import { ALERT_MSG, CalcFormSelectOptions, DM_EVENT, MATERIALS, SECTIONS } from '@shared/data';
import CalcBuilder from '@/class/CalcBuilder';
import NumberField from '@/fields/NumberField';
import SchemeElements, { ErrorsLevel } from '@/class/SchemeElements';
import CompareData from '@/class/CompareData';
import array_chunk from '@shared/utils/locutus/array_chunk.js';
import { average, getLengthByFlange, getTypedKeys, isChecked, percent, round, strCompare } from '@/includes/utils';
import empty from '@shared/utils/locutus/empty';
import SearchField from '@/fields/SearchField';
import { calcMontageTotals } from '@/includes/helpers';
import NumblectField from '@/fields/NumblectField';
const atcmpSel = '#calcZV__autocomplete';
export var EnumSection;
(function (EnumSection) {
    EnumSection["Square"] = "\u041F\u0440\u044F\u043C\u043E\u0443\u0433\u043E\u043B\u044C\u043D\u043E\u0435";
    EnumSection["Round"] = "\u041A\u0440\u0443\u0433\u043B\u043E\u0435";
})(EnumSection || (EnumSection = {}));
function getSmallerNumber(value, list) {
    if (!list.length)
        return undefined;
    let res = undefined;
    for (let i = list.length - 1; i >= 0; i--) {
        const min = value >= list[i];
        const max = value < list.at(-1);
        if (!(min && max))
            continue;
        res = list[i];
        break;
    }
    if (res === null)
        res = value > list.at(-1) ? list.at(-1) : list[0];
    return res;
}
function getNearlyIndex(value, data, key) {
    const list = data.map(it => +it[key]);
    const near = getSmallerNumber(value, list);
    if (near === undefined)
        return -1;
    return data.findIndex((it) => it[key] == near);
}
function getPercentFromNumber(n1, n2) {
    return (n1 / 100 * n2).toFixed(0);
}
function initLinkedAutofill(scope, data, name, value) {
    const percents = scope.params.reduce((acc1, k1) => {
        const obj = scope.params.reduce((acc2, k2) => {
            if (k1 === k2)
                return acc2;
            acc2[`${k1}_${k2}`] = round(average(data.map((it) => percent(it[k1], it[k2]))));
            return acc2;
        }, {});
        acc1 = Object.assign(Object.assign({}, acc1), obj);
        return acc1;
    }, {});
    for (const k of scope.params) {
        if (k === name)
            continue;
        const current = percents[`${k}_${name}`];
        scope.fields[k].value = getPercentFromNumber(value, current);
    }
}
class Calculator {
    buildSearchValues(product) {
        var _a, _b, _c, _d, _e, _f;
        product = product || ((_a = Object.keys(window === null || window === void 0 ? void 0 : window.calcZV_goods)) === null || _a === void 0 ? void 0 : _a[0]);
        if (!product)
            return [];
        const elements = [];
        const keys = Object.keys(((_c = (_b = window === null || window === void 0 ? void 0 : window.calcZV_goods) === null || _b === void 0 ? void 0 : _b[product]) === null || _c === void 0 ? void 0 : _c.items) || {});
        for (const key of keys) {
            const item = (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.calcZV_goods) === null || _d === void 0 ? void 0 : _d[product]) === null || _e === void 0 ? void 0 : _e.items) === null || _f === void 0 ? void 0 : _f[key];
            if (typeof item !== 'object')
                continue;
            elements.push(...Object.keys(item.items));
        }
        return elements;
    }
    getSearchedPath(element) {
        var _a, _b, _c, _d, _e;
        const product = this.fields.goods.value;
        if (this.isNowAirDuct())
            return null;
        const keys = Object.keys(((_b = (_a = window === null || window === void 0 ? void 0 : window.calcZV_goods) === null || _a === void 0 ? void 0 : _a[product]) === null || _b === void 0 ? void 0 : _b.items) || {});
        for (const key of keys) {
            const item = (_e = (_d = (_c = window === null || window === void 0 ? void 0 : window.calcZV_goods) === null || _c === void 0 ? void 0 : _c[product]) === null || _d === void 0 ? void 0 : _d.items) === null || _e === void 0 ? void 0 : _e[key];
            if (typeof item !== 'object')
                continue;
            const items = Object.keys(item.items);
            if (items.includes(element))
                return [key, element];
        }
        return null;
    }
    constructor() {
        var _a, _b;
        this.rootClass = 'calcZV';
        this.cartClass = 'calcZV__cart';
        this.airDuctTexts = {
            calcZV_elements: `<h3><img src="https://ilysan.ru/wp-content/uploads/2024/catalog/ductmaster.png" alt="" class="scale" style="width: 40px; height: auto; "/>Ductmaster</h3>`,
            ACmaster_elements: `<h3><img src="https://ilysan.ru/wp-content/uploads/2024/catalog/ductmaster.png" alt="" class="scale" style="width: 40px; height: auto; "/>ACmaster</h3>`,
            Ultra_elements: `<h3><img src="https://ilysan.ru/wp-content/uploads/2024/catalog/ductmaster.png" alt="" class="scale" style="width: 40px; height: auto; "/>Ultra</h3>`,
            Concrete_elements: `<h3><img src="https://ilysan.ru/wp-content/uploads/2024/catalog/ductmaster.png" alt="" class="scale" style="width: 40px; height: auto; "/>Concrete</h3>`,
        };
        this.goodsFieldLabel = `<a href="#popmake-" title="Каталог"><img src="https://ilysan.ru/wp-content/uploads/2024/catalog/output1.gif" title="Каталог" alt="" class="scale" style="width: 65px; height: auto; "/>`;
        this.airDuctLabels = {
            calcZV_elements: {
                search: `<a href="#popmake-" title="Поиск">🔍Поиск`,
                material: `<a href="#popmake-2976" title="Гост"><img src="https://ilysan.ru/wp-content/uploads/2024/catalog/steel.png" title="Нержавеющая сталь" alt="" class="scale" style="width: 85px; height: auto; "/><img src="/wp-content/uploads/2024/catalog/steel2.png" title="Оцинкованная сталь" alt="" class="scale" style="width: 85px; height: auto; "/><a href="#popmake-3230"><img src="https://ilysan.ru/wp-content/uploads/2024/catalog/bird.png" title="" alt="" class="scale" style="width: 85px; height: auto; "/>📎`,
                section: `<h3><a href="#popmake-2986" title="Прямоугольное сечение воздуховода">⏹️<a href="#popmake-2986" title="Круглое сечение воздуховода">⭕<a href="#popmake-2982" title="Плоскоовальное сечение воздуховода"><img src="https://ilysan.ru/wp-content/uploads/2024/catalog/oval.png" alt="" class="scale" style="width: 30px; height: auto; "/></h3>`,
                element: 'Элемент 1',
            },
            ACmaster_elements: {
                search: `<a href="#popmake-" title="Поиск">🔍Поиск`,
                material: `Material 2`,
                section: `Section 2`,
                element: 'Элемент 2',
            },
            Ultra_elements: {
                search: `<a href="#popmake-" title="Поиск">🔍Поиск`,
                material: `Material 3`,
                section: 'Section 3',
                element: 'Элемент 3',
            },
            Concrete_elements: {
                search: `<a href="#popmake-" title="Поиск">🔍Поиск`,
                material: `Material 4`,
                section: `Section 4`,
                element: 'Элемент 4',
            },
        };
        this.autocomplete = isChecked(atcmpSel, true);
        this.dmEvents = {
            update: new CustomEvent(DM_EVENT.update),
            addMontage: new CustomEvent(DM_EVENT.addMontage),
            delMontage: new CustomEvent(DM_EVENT.delMontage),
        };
        const prodEl = document.querySelector(`.${this.rootClass}__userAdditionalInput`);
        if (!prodEl)
            throw new Error('Элемент ...__userAdditionalInput не найден');
        this.prodEl = prodEl;
        const mainInputEl = document.querySelector(`.${this.rootClass}__mainInput`);
        if (!mainInputEl)
            throw new Error('Элемент ...__mainInput не найден');
        this.mainInputEl = mainInputEl;
        const firstElementKey = Object.keys(this.airDuctTexts)[0];
        if (!((_a = MATERIALS === null || MATERIALS === void 0 ? void 0 : MATERIALS[firstElementKey]) === null || _a === void 0 ? void 0 : _a.length)) {
            throw new Error('Список материалов не должен быть пустым!');
        }
        if (!((_b = SECTIONS === null || SECTIONS === void 0 ? void 0 : SECTIONS[firstElementKey]) === null || _b === void 0 ? void 0 : _b.length)) {
            throw new Error('Список сечений не должен быть пустым!');
        }
        const searchConfig = {
            suggestions: this.buildSearchValues(),
            isAdaptiveField: true,
            minFieldWidth: '100px',
            showHintsAfterSelect: true,
            isSortHints: false,
            searchDelay: 250,
            isWithMatchMark: true,
            isSimpleSearch: false,
            hintsLimit: -1,
            inputFieldProps: {
                placeholder: 'Искать в элементах',
            },
        };
        const currentSections = SECTIONS[firstElementKey];
        const currentMaterials = MATERIALS[firstElementKey];
        const currentLabels = this.airDuctLabels[firstElementKey];
        this.fields = {
            goods: new SelectField(this.goodsFieldLabel, this.getGoodsOptions()),
            search: new SearchField(currentLabels.search, searchConfig),
            material: new SelectField(currentLabels.material, currentMaterials),
            section: new SelectField(currentLabels.section, currentSections),
            element: new ElementField(currentLabels.element, currentMaterials[0], currentSections[0], firstElementKey),
        };
        this.fields.search.block.style.setProperty('display', 'none');
        this.moreGoodsSelects = [];
        this.moreGoodsRows = [];
        this.elements = new SchemeElements(this.fields);
        this.params = this.getMainFieldsValues();
        this.events();
    }
    events() {
        const pushMontage = (cart) => {
            const obj = calcMontageTotals(cart);
            const montageText = obj.text;
            const { count, square, base, totalPrice } = obj;
            const item = {
                count: count,
                price: base.toFixed(2),
                angleCount: 0,
                angle2Count: 0,
                angle3Count: 0,
                description: montageText,
                tireLength: 0,
                tire2Len: 0,
                tire3Len: 0,
                square: square.toFixed(3),
                excelFields: [],
                standardName: montageText,
                thickness: '—',
                framesInfoForExcel: [],
                type: 'montage',
                totalPrice: totalPrice.toFixed(2),
                supplierData: [],
            };
            LocalCart.addItem(item);
        };
        const handler = () => {
            const local = LocalCart.list;
            if (!local.length)
                return;
            if (!isChecked('#calcZV__autowork', true)) {
                LocalCart.save(local.filter(it => it.type !== 'montage'));
                localStorage.removeItem('_dm_calc_montage');
            }
            else {
                const list = local.filter(it => it.type === 'airduct');
                if (!list.length) {
                    localStorage.removeItem('_dm_calc_montage');
                    return;
                }
                pushMontage(local);
                localStorage.setItem('_dm_calc_montage', '1');
            }
            window.dispatchEvent(this.dmEvents.update);
        };
        $('#calcZV__autowork input[type="checkbox"]').on('change', handler);
        $(window).on('load', () => {
            if (localStorage.getItem('_dm_calc_montage')) {
                $('#calcZV__autowork input[type="checkbox"]').attr('checked', '');
            }
        });
    }
    initialize() {
        const row1 = HtmlBuilder.createRow();
        const row2 = HtmlBuilder.createRow();
        row1.append(this.fields.goods.block, this.fields.search.block, this.fields.material.block);
        row2.append(this.fields.section.block, this.fields.element.block);
        this.mainInputEl.append(row1, row2);
        this.fields.goods.onChange(this.productChanged.bind(this));
        this.fields.material.onChange(this.materialOrSectionChanged.bind(this, 1, true));
        this.fields.section.onChange(this.materialOrSectionChanged.bind(this, 2, true));
        this.fields.element.onChange(this.elementChanged.bind(this));
        this.fields.search.onChange(() => {
            const path = this.getSearchedPath(this.fields.search.value);
            if (!path) {
                console.warn('Не удалось найти искомое значение!');
                return;
            }
            this.moreGoodsSelects[0].value = path[0];
            this.moreGoodsSelects[1].value = path[1];
            this.fields.search.value = '';
            this.fields.search.block.querySelector('input').blur();
        });
        this.fields.goods.nice();
        this.fields.material.nice();
        this.fields.section.nice();
        $(atcmpSel).on('change', () => {
            this.autocomplete = isChecked(atcmpSel, true);
            this.applyScheme();
        });
        try {
            this.applyScheme();
        }
        catch (e) {
            console.error(e);
        }
    }
    addCartItem() {
        const builder = new CalcBuilder(this.fields, this.moreGoodsSelects, this.elements);
        const elementKey = this.getNeedElementsKey(this.fields.goods.value);
        const isAirDuct = this.getIsAirDuct(this.fields.goods.value);
        if (isAirDuct && !elementKey)
            return;
        const item = builder.build(isAirDuct, elementKey);
        if (!item || (item.isList ? !(item === null || item === void 0 ? void 0 : item.value.length) : !item.value))
            return;
        if (this.isNowAirDuct())
            (item.isList ? item.value : [item.value]).forEach((it) => it && LocalCart.addItem(it));
        else {
            const it = (item.isList ? item.value[0] : item.value);
            const index = LocalCart.list.findIndex((ot) => {
                return ot.description === it.description;
            });
            if (index === -1)
                LocalCart.addItem(it);
            else {
                const same = LocalCart.getItem(index);
                const found = Object.assign(Object.assign({}, same), { count: 0, square: null });
                const created = Object.assign(Object.assign({}, it), { count: 0, square: null });
                if (!CompareData.isEquals(found, created))
                    LocalCart.addItem(it);
                else {
                    const count = same.count + it.count;
                    LocalCart.changeItem(index, (prev) => (Object.assign(Object.assign({}, prev), { count })));
                }
            }
        }
        alert(ALERT_MSG.ITEM_ADDED);
        window.dispatchEvent(this.dmEvents.update);
    }
    getGoodsOptions() {
        return [
            ...Object.values(this.airDuctTexts),
            ...Object.keys((window === null || window === void 0 ? void 0 : window.calcZV_goods) || {}),
        ];
    }
    removeStartingFrom(ind) {
        var _a, _b;
        if (ind >= this.moreGoodsSelects.length)
            return;
        const oldInd = ind;
        if (ind % 2) {
            $(this.moreGoodsSelects[ind].block).off('change');
            this.moreGoodsSelects[ind].remove();
            ind++;
        }
        for (let i = ind; i < this.moreGoodsSelects.length; i++) {
            $(this.moreGoodsSelects[i].block).off('change');
            this.moreGoodsSelects[i].remove();
        }
        for (let i = ind / 2; i < this.moreGoodsRows.length; i++) {
            (_b = (_a = this.moreGoodsRows) === null || _a === void 0 ? void 0 : _a[i]) === null || _b === void 0 ? void 0 : _b.remove();
        }
        this.moreGoodsSelects.splice(oldInd, this.moreGoodsSelects.length - oldInd);
        this.moreGoodsRows.splice(ind / 2, this.moreGoodsRows.length - ind / 2);
    }
    fillMoreSelects(start) {
        var _a, _b;
        const product = this.fields.goods.value;
        let current = (_a = window.calcZV_goods) === null || _a === void 0 ? void 0 : _a[product];
        if (!current)
            throw new Error();
        let photo = null;
        for (let i = 0; i < start; i++) {
            if (typeof current !== 'object')
                break;
            if ('photo' in current)
                photo = current.photo;
            const next = (_b = this.moreGoodsSelects) === null || _b === void 0 ? void 0 : _b[i];
            if (!next)
                break;
            current = current === null || current === void 0 ? void 0 : current.items[next.value];
        }
        let k = start;
        while (typeof current === 'object') {
            if (!current)
                break;
            if ('photo' in current)
                photo = current.photo;
            current = this.addSelectOrNumberInRowIfNeed(k, current, true);
            k++;
        }
        this.addSelectOrNumberInRowIfNeed(k, null, false);
        this.showElemImage(photo);
    }
    addSelectOrNumberInRowIfNeed(k, current, isSelect) {
        if (k % 2 === 0) {
            const row = HtmlBuilder.createRow();
            this.moreGoodsRows.push(row);
            this.mainInputEl.append(row);
        }
        const push = (elem) => {
            var _a;
            this.moreGoodsSelects.push(elem);
            (_a = this.moreGoodsRows.at(-1)) === null || _a === void 0 ? void 0 : _a.append(elem.block);
        };
        if (!isSelect) {
            const elem = new NumberField('Количество', '1');
            push(elem);
            return null;
        }
        if (!(current === null || current === void 0 ? void 0 : current.items))
            return;
        const title = (current === null || current === void 0 ? void 0 : current.title) || 'Название';
        const options = Object.keys(current.items);
        const elem = new SelectField(title, options);
        const kClosure = k;
        elem.onChange(() => {
            this.removeStartingFrom(kClosure + 1);
            this.fillMoreSelects(kClosure + 1);
        });
        push(elem);
        elem.nice();
        const firstKey = options.length > 0 ? options[0] : null;
        return firstKey ? current.items[firstKey] : null;
    }
    showElemImage(img) {
        var _a;
        const photoEl = document.querySelector('.calcZV__photo');
        if (!photoEl)
            return;
        photoEl.style.background = typeof img === 'string'
            ? `url('${(_a = window === null || window === void 0 ? void 0 : window.calcData) === null || _a === void 0 ? void 0 : _a.basePhotoUrl}${img}') no-repeat center / contain`
            : '';
    }
    hangBlurOnFormFields({ elem, type, name }) {
        const buildScopeData = (params, fields, elems) => (Object.assign({ params, fields: this.elements.getFormFields(fields), logic: [] }, ((elems === null || elems === void 0 ? void 0 : elems.length) ? { elements: elems } : {})));
        const getScopeLogicParams = (s, e, types, scope, strict = true) => {
            const compare = (str) => strCompare(this.fields.element.value, str);
            const elem = (scope === null || scope === void 0 ? void 0 : scope.elements) || e;
            const isElement = elem !== null
                ? Array.isArray(elem) ? elem.some(it => compare(it)) : compare(elem)
                : true;
            return [
                this.fields.section.value === s, isElement,
                types.includes(type), scope.params.includes(name),
                Object.values(scope.fields)[strict ? 'every' : 'some'](Boolean),
            ];
        };
        function isNumberField(element) {
            return element instanceof NumberField;
        }
        function isNumblectField(element) {
            return element instanceof NumblectField;
        }
        const pryamik = () => {
            const params = ['A', 'B', 'A1', 'B1', 'a', 'b'];
            const scope = buildScopeData(params, params);
            scope.logic.push(...getScopeLogicParams(EnumSection.Square, null, ['number', 'numblect'], scope, false), this.fields.element.value !== 'Зонт крышный');
            if (!(scope.logic.every(Boolean)))
                return;
            const calc = (part, i) => i + part * 2;
            const key = (i, name) => { var _a; return (((_a = [name, name.replace('1', ''), name.toUpperCase()]) === null || _a === void 0 ? void 0 : _a[i]) || name); };
            const onAutofillHandler = () => {
                const params = this.getElementsValues(scope.params);
                const chunks = array_chunk(scope.params, 2);
                const part = chunks.findIndex(it => it.includes(name));
                if (part === -1)
                    return;
                const index = chunks[part].indexOf(name);
                const value = +((params === null || params === void 0 ? void 0 : params[calc(part, index)]) || 0);
                if (!value)
                    return;
                const invert = chunks[part][+!index];
                if (!invert || (name !== 'A' && !empty(scope.fields[invert].value)))
                    return;
                const { pryamik } = window === null || window === void 0 ? void 0 : window.calcZV_autofillData;
                const find = (pryamik || []).find(it => it[key(part, name)] === value);
                if (!find)
                    return;
                scope.fields[invert].value = find[key(part, invert)];
            };
            const isNumblect = isNumblectField(elem);
            if (isNumblect)
                elem.onChange(onAutofillHandler);
            if (isNumberField(elem) || isNumblect)
                elem.onBlur(onAutofillHandler);
        };
        const stire = () => {
            const scope = buildScopeData(['A', 'B', 'a', 'b'], ['flange1', 'flange2']);
            scope.logic.push(...getScopeLogicParams(EnumSection.Square, null, ['number', 'numblect'], scope));
            if (!(scope.logic.every(Boolean)))
                return;
            const onAutofillHandler = () => {
                const values = this.getElementsValues(scope.params);
                const chunks = array_chunk(values, 2);
                if (!(chunks[0].every(Boolean) || chunks[1].every(Boolean)))
                    return;
                const calc = (chunk) => {
                    var _a;
                    const [a, b] = chunk;
                    const flange = a + b >= 1000 || Math.max(a, b) >= 700;
                    return ((_a = CalcFormSelectOptions.flange) === null || _a === void 0 ? void 0 : _a[Number(flange)]) || 'Шина 20';
                };
                const keys = getTypedKeys(scope.fields);
                if (chunks[1].every(it => it === null))
                    keys.forEach(k => scope.fields[k].value = calc(chunks[0]));
                else
                    keys.forEach((k, i) => scope.fields[k].value = calc(chunks[i]));
            };
            const isNumblect = isNumblectField(elem);
            if (isNumblect)
                elem.onChange(onAutofillHandler);
            if (isNumberField(elem) || isNumblect)
                elem.onBlur(onAutofillHandler);
        };
        const sperehod = () => {
            const scope = buildScopeData(['A', 'B', 'a', 'b'], ['L']);
            scope.logic.push(...getScopeLogicParams(EnumSection.Square, '%Переход П%', ['number', 'numblect'], scope));
            if (!(scope.logic.every(Boolean)))
                return;
            const onAutofillHandler = () => {
                const values = this.getElementsValues(scope.params);
                const [upper, lower] = array_chunk(values, 2);
                if (!(upper.every(Boolean) || lower.every(Boolean)))
                    return;
                const [A, B, a, b] = values;
                const P1 = upper.every(Boolean) ? (A + B) * 2 : 0;
                const P2 = lower.every(Boolean) ? (a + b) * 2 : 0;
                const value = Math.max(P1, P2) >= 2500 ? 500 : 300;
                const field = scope.fields.L;
                field.value = value;
                field.min = value;
            };
            const isNumblect = isNumblectField(elem);
            if (isNumblect)
                elem.onChange(onAutofillHandler);
            if (isNumberField(elem) || isNumblect)
                elem.onBlur(onAutofillHandler);
        };
        const rperehod = () => {
            const scope = buildScopeData(['D', 'D1'], ['L']);
            scope.logic.push(...getScopeLogicParams(EnumSection.Round, '%Переход К-К-%', ['number', 'numblect'], scope));
            if (!(scope.logic.every(Boolean)))
                return;
            const param = (str) => { var _a; return ((_a = str.split('-Т')[1]) === null || _a === void 0 ? void 0 : _a[0]) === '1' ? 0.73 : 0.36; };
            const onAutofillHandler = () => {
                const values = this.getElementsValues(scope.params);
                if (!values.every(Boolean))
                    return;
                const safety = values.map(n => +(n || 0));
                const value = Math.max(...safety) - Math.min(...safety);
                scope.fields.L.value = Math.round((value + 100) / param(this.fields.element.value));
            };
            const isNumblect = isNumblectField(elem);
            if (isNumblect)
                elem.onChange(onAutofillHandler);
            if (isNumberField(elem) || isNumblect)
                elem.onBlur(onAutofillHandler);
        };
        const tolshchina = () => {
            const scope = buildScopeData(['A', 'B', 'a', 'b'], ['thickness']);
            scope.logic.push(...getScopeLogicParams(EnumSection.Square, null, ['number', 'numblect'], scope));
            if (!(scope.logic.every(Boolean)))
                return;
            function getThicknessByMax(max) {
                if (max < 350)
                    return '0,5';
                else if (max >= 350 && max < 1000)
                    return '0,7';
                else if (max >= 1000 && max < 1500)
                    return '1,0';
                else
                    return '1,2';
            }
            const onAutofillHandler = () => {
                const values = this.getElementsValues(scope.params);
                const chunks = array_chunk(values, 2);
                if (!(chunks[0].every(Boolean) || chunks[1].every(Boolean)))
                    return;
                const value = Math.max(...values.map(n => +(n || 0)));
                if (!value)
                    return;
                const field = scope.fields['thickness'];
                field.value = getThicknessByMax(value);
            };
            const isNumblect = isNumblectField(elem);
            if (isNumblect)
                elem.onChange(onAutofillHandler);
            if (isNumberField(elem) || isNumblect)
                elem.onBlur(onAutofillHandler);
        };
        const sflange = () => {
            const sflange = buildScopeData(['flange1'], ['L'], ['Заглушка', 'Заглушка с сеткой']);
            sflange.logic.push(...getScopeLogicParams(EnumSection.Square, null, ['roof'], sflange));
            if (!(sflange.logic.every(Boolean) && elem instanceof SelectField))
                return;
            elem.onChange(() => {
                const field = sflange.fields['L'];
                field.setValue(getLengthByFlange(elem.value));
            });
        };
        const prymoshov = () => {
            const prymoshov = buildScopeData(['D'], ['thickness']);
            prymoshov.logic.push(...getScopeLogicParams(EnumSection.Round, null, ['number', 'numblect'], prymoshov), this.fields.element.value !== 'Прямой спирально-навивной');
            if (!(prymoshov.logic.every(Boolean)))
                return;
            const isNumblect = isNumblectField(elem);
            const isNumber = isNumberField(elem);
            if (!isNumber && !isNumblect)
                return;
            const onAutofillHandler = () => {
                const value = +elem.value;
                prymoshov.fields.thickness.value = (() => {
                    if (value >= 100 && value < 355)
                        return '0,5';
                    else if (value >= 355 && value < 900)
                        return '0,7';
                    else if (value >= 900)
                        return '1,0';
                    else
                        return '0,5';
                })();
            };
            if (isNumblect)
                elem.onChange(onAutofillHandler);
            elem.onBlur(onAutofillHandler);
        };
        const spiralnaiv = () => {
            const spiralnaiv = buildScopeData(['D'], ['thickness']);
            spiralnaiv.logic.push(...getScopeLogicParams(EnumSection.Round, 'Прямой спирально-навивной', ['number', 'numblect'], spiralnaiv));
            if (!(spiralnaiv.logic.every(Boolean)))
                return;
            const getThickness = (value) => {
                if (value >= 100 && value < 400)
                    return '0,5';
                else if (value >= 400 && value < 900)
                    return '0,7';
                else if (value >= 900)
                    return '1,0';
                else
                    return '0,5';
            };
            const onAutofillHandler = () => {
                spiralnaiv.fields['thickness'].value = getThickness(+elem.value);
            };
            const isNumblect = isNumblectField(elem);
            if (isNumblect)
                elem.onChange(onAutofillHandler);
            if (isNumberField(elem) || isNumblect)
                elem.onBlur(onAutofillHandler);
        };
        const rcolpak = () => {
            const rcolpak = buildScopeData(['D', 'D1', 'H'], ['thickness', 'D', 'D1', 'H']);
            rcolpak.logic.push(...getScopeLogicParams(EnumSection.Round, 'Зонт крышный', ['number', 'numblect'], rcolpak));
            if (!(rcolpak.logic.every(Boolean)))
                return;
            const data = window.calcZV_autofillData.roundColpak;
            const onAutofillHandler = () => {
                const find = data.find(it => it[name] === String(elem.value));
                if (find !== undefined) {
                    rcolpak.params.forEach((key) => {
                        rcolpak.fields[key].value = find[key];
                    });
                    rcolpak.fields['thickness'].value = find.t;
                    return;
                }
                const nearly = getNearlyIndex(+elem.value, data, name);
                if (nearly === -1 || nearly >= data.length)
                    return;
                rcolpak.fields['thickness'].value = data[nearly].t;
                const getData = (i) => ({
                    D1: +data[nearly + i].D1, D: +data[nearly + i].D, H: +data[nearly + i].H,
                });
                initLinkedAutofill(rcolpak, [getData(0), getData(1)], name, +elem.value);
            };
            const isNumblect = isNumblectField(elem);
            if (isNumblect)
                elem.onChange(onAutofillHandler);
            if (isNumberField(elem) || isNumblect)
                elem.onBlur(onAutofillHandler);
        };
        const scolpak = () => {
            const params = ['A', 'B'];
            const scope = buildScopeData(params, [...params, 'A1', 'B1', 'h1', 'h2', 'h3']);
            scope.logic.push(...getScopeLogicParams(EnumSection.Square, 'Зонт крышный', ['number', 'numblect'], scope));
            if (!(scope.logic.every(Boolean)))
                return;
            const data = window.calcZV_autofillData.squareColpak;
            const onAutofillHandler = () => {
                const find = data.find((it) => {
                    const p = scope.params[+!scope.params.indexOf(name)];
                    return it[name] === elem.value && it[p] === scope.fields[p].value;
                });
                if (!find)
                    return;
                Object.keys(scope.fields).forEach((k) => {
                    scope.fields[k].value = k === 'h3' ? 100 : find[k];
                });
            };
            const isNumblect = isNumblectField(elem);
            if (isNumblect)
                elem.onChange(onAutofillHandler);
            if (isNumberField(elem) || isNumblect)
                elem.onBlur(onAutofillHandler);
        };
        pryamik();
        stire();
        sperehod();
        rperehod();
        tolshchina();
        sflange();
        prymoshov();
        spiralnaiv();
        rcolpak();
        scolpak();
    }
    getElementsValues(paramNames) {
        return paramNames.map((it) => {
            return this.elements.getSafeValue(it, null, ErrorsLevel.NONE);
        });
    }
    getNeedElementsKey(airDuctText) {
        const find = Object.entries(this.airDuctTexts).find(([, value]) => value.localeCompare(airDuctText) === 0);
        return find === null || find === void 0 ? void 0 : find[0];
    }
    applyScheme() {
        var _a, _b, _c, _d;
        if (this.elements)
            this.elements.remove();
        const [g, , s, e] = this.getMainFieldsValues();
        const elementsKey = this.getNeedElementsKey(g);
        if (!elementsKey)
            return;
        const scheme = (_b = (_a = window === null || window === void 0 ? void 0 : window.calcZV_schemes) === null || _a === void 0 ? void 0 : _a[s]) === null || _b === void 0 ? void 0 : _b[e];
        const elemInfo = (_d = (_c = window === null || window === void 0 ? void 0 : window[elementsKey]) === null || _c === void 0 ? void 0 : _c[s]) === null || _d === void 0 ? void 0 : _d[e];
        if (!(elemInfo && scheme))
            return;
        const { photo } = elemInfo;
        this.elements.update(scheme);
        if (this.autocomplete) {
            this.elements.each((obj) => this.hangBlurOnFormFields(obj));
        }
        this.showElemImage(photo || null);
        this.prodEl.append(...this.elements.rows);
        this.elements.nice();
    }
    getIsAirDuct(product) {
        return Object.values(this.airDuctTexts).includes(product);
    }
    isNowAirDuct() {
        return this.getIsAirDuct(this.fields.goods.value);
    }
    materialOrSectionChanged(t, applyScheme = true) {
        if (this.isParamEquals(t))
            return;
        const g = this.fields.goods.value;
        const m = this.fields.material.value;
        const s = this.fields.section.value;
        const elementsKey = this.getNeedElementsKey(g);
        if (!elementsKey)
            return;
        this.fields.element.updateElement(m, s, elementsKey);
        if (applyScheme)
            this.applyScheme();
        this.params[1] = m;
        this.params[2] = s;
    }
    productChanged() {
        const product = this.fields.goods.value;
        if (this.isParamEquals(0))
            return;
        const values = ['block', 'none'];
        const showDuctSelects = this.getIsAirDuct(product);
        const displayValue = values[+!showDuctSelects];
        this.fields.material.block.style.display = displayValue;
        this.fields.section.block.style.display = displayValue;
        this.fields.element.block.style.display = displayValue;
        this.fields.search.block.style.display = values[+showDuctSelects];
        this.prodEl.style.display = displayValue;
        this.removeStartingFrom(0);
        if (!showDuctSelects) {
            const values = this.buildSearchValues(product);
            this.fields.search.changeOptions(values, false);
            this.showElemImage(null);
            this.fillMoreSelects(0);
        }
        else {
            let elementsKey = this.getNeedElementsKey(product);
            if (!elementsKey) {
                elementsKey = 'calcZV_elements';
                console.error('Не удалось найти текущий ключ calcZV_*_elements');
            }
            const currentMaterials = (MATERIALS === null || MATERIALS === void 0 ? void 0 : MATERIALS[elementsKey]) || [];
            const currentSections = (SECTIONS === null || SECTIONS === void 0 ? void 0 : SECTIONS[elementsKey]) || [];
            const currentLabels = this.airDuctLabels[elementsKey];
            this.fields.material.label = currentLabels.material;
            this.fields.material.changeOptions(currentMaterials);
            this.materialOrSectionChanged(1, false);
            this.fields.section.label = currentLabels.section;
            this.fields.section.changeOptions(currentSections);
            this.materialOrSectionChanged(2, false);
            this.fields.search.label = currentLabels.search;
            this.fields.element.label = currentLabels.element;
            this.applyScheme();
        }
        this.params[0] = product;
    }
    elementChanged() {
        if (this.isParamEquals(3))
            return;
        else
            this.applyScheme();
        this.params[3] = this.fields.element.value;
    }
    isParamEquals(index) {
        const param = this.params[index];
        switch (index) {
            case 0:
                return this.fields.goods.value === param;
            case 1:
                return this.fields.material.value === param;
            case 2:
                return this.fields.section.value === param;
            case 3:
                return this.fields.element.value === param;
        }
    }
    getMainFieldsValues() {
        return [
            this.fields.goods.value,
            this.fields.material.value,
            this.fields.section.value,
            this.fields.element.value,
        ];
    }
}
export default Calculator;
